import {
  TIPO_TARJETA_BANCARIA,
  TipoTarjetaBancariaType,
} from "api/Types/TipoTarjetaBancaria"

export const TIPO_TARJETA: Record<TipoTarjetaBancariaType, string> = {
  [TIPO_TARJETA_BANCARIA.CREDITO]: "Crédito",
  [TIPO_TARJETA_BANCARIA.DEBITO]: "Débito",
  [TIPO_TARJETA_BANCARIA.PREPAGO]: "Prepago",
}
